import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'alert-status-tab',
  template: `
    <div [hidden]="!active" class="pane">
      <ng-content></ng-content>
    </div>
  `,
})
export class AlertStatusTab implements OnInit {

  constructor() { }

  ngOnInit(): void { }
  @Input('label') title: string;
  @Input() active = false;
  @Input() disable:boolean = false;
  @Input() closable:boolean =false;
  @Input() count:number;
  @Input() icon:string;

}
